<template>
    <ValidationObserver v-slot="{ handleSubmit, invalid }">
        <b-form @submit.prevent="handleSubmit(saveCategoryData)">  
            <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
                <template v-slot:header>
                    <p class="mb-0" style="font-size: 21px">Actualizar Categoría</p>
                </template>
                <b-card-text>
                    <b-alert show variant="danger" v-if="errors">
                        <ul >
                            <li v-for="(item, index) in errors" :key="index">{{ item }}</li>
                        </ul>
                    </b-alert>
                    <b-tabs content-class="mt-3" justified>
                        <b-tab title="Información Básica" active>
                            <b-row>        
                                <b-col cols="12" md="6">
                                    <ValidationProvider name="codigo" rules="required|min:1" v-slot="{ errors, valid }">
                                        <b-form-group 
                                            label="Código:">
                                            <b-form-input
                                                v-model="update.codigo"
                                                type="text"
                                                autocomplete="off"
                                                required
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                placeholder="Ingrese el código"
                                                ></b-form-input>
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <ValidationProvider name="nombre" rules="required|min:3" v-slot="{ errors, valid }">
                                        <b-form-group 
                                            label="Nombre:">
                                            <b-form-input
                                                v-model="update.nombre"
                                                type="text"
                                                autocomplete="off"
                                                required
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                placeholder="Ingrese el nombre"
                                                ></b-form-input>
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <ValidationProvider name="categoria" v-slot="{ errors, valid }">
                                        <b-form-group 
                                            label="Selecciona categoria:">
                                            <b-form-select
                                                v-model="update.categoria_padre_id"
                                                :options="categoriesList"
                                                class="mb-3"
                                                value-field="id"
                                                text-field="nombre"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                >
                                                <template #first>
                                                    <b-form-select-option value="0">SELECCIONE</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <b-form-group 
                                        label="Estado:"
                                        label-for="status">
                                        <b-row cl>
                                        <b-form-checkbox v-model="update.status" name="status" switch class="ml-3" />
                                        <span v-if="update.status === true">Activo</span>
                                        <span v-else>Inactivo</span>
                                        </b-row>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Atributos">
                            <b-row>        
                                <b-col cols="12" md="6">
                                    <table class="table">
                                        Atributos Disponibles
                                        <tbody>
                                            <tr v-for="(item, index) in activeAttributeList" :key="index">
                                                <template  v-if="!currentAttributes.some(e => e.id === item.id)">
                                                    <td >{{item.nombre}}</td>
                                                    <td>
                                                        <b-button variant="info" v-b-tooltip.hover.right title="Agregar" class="text-white" size="sm"
                                                        @click.prevent="addAttributeItemToAsigned(item)">
                                                            <b-icon icon="check"></b-icon>
                                                        </b-button>
                                                    </td>
                                                </template >
                                            </tr>                                            
                                        </tbody>
                                    </table>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <table class="table">
                                        Atributos Asignados
                                        <tbody>
                                            <tr v-for="(item, index) in currentAttributes" :key="index">
                                                <td >{{item.nombre}}</td>
                                                <td>
                                                    <b-button variant="danger" v-b-tooltip.hover.right title="Eliminar" class="text-white" size="sm"
                                                    @click.prevent="removeAsignedAttributeItem(index)">
                                                        <b-icon icon="trash-fill"></b-icon>
                                                    </b-button>
                                                </td>
                                            </tr>                                            
                                        </tbody>
                                    </table>
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                    
                </b-card-text>
                <template v-slot:footer>
                    <b-button variant="danger" class="mr-2" @click.prevent="back">
                        Cancelar
                    </b-button>
                    <b-button variant="success" :disabled="invalid" type="submit">
                        Actualizar
                    </b-button>
                </template>
            </b-card>
        </b-form>
    </ValidationObserver>
    
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
export default {
    data(){
        return{
            errors: "",
            update: {
                codigo: '',
                nombre: '',
                categoria_padre_id: 0,
                status: false
            },
            categoriesList: [],
            activeAttributeList: [],
            currentAttributes: [],
        }
    },
     created(){
        this.getCategoriesList();
        this.getActiveAttributeList();
        this.getCategoryData();
    },
    methods:{
        ...mapMutations(['setLoading']),
        ...mapActions('configuration', {
          _getCategoriesEmpresa: 'getCategoriesEmpresa',
        }),  
        async getCategoryData(){
            this.setLoading(true)
            this.confirm = "Actualizar";
            await this.$conectar.post('/empresa/categories/get-category-data', {id: this.$route.params.id})
            .then(response =>{
                this.update = response.data.categoryData;
                this.currentAttributes = response.data.categoryData.currentAttributes;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getActiveAttributeList(){
            this.setLoading(true)
            await this.$conectar.post('/empresa/categories/get-active-attributes-list')
            .then(response =>{
                this.activeAttributeList = response.data.activeAttributeList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async saveCategoryData(){
            this.setLoading(true)
            this.errors = "";
            this.update.atributos = this.currentAttributes;
            await this.$conectar.post('/empresa/categories/save-category', this.update)
            .then(response =>{
                if(response.data.errors){
                    this.errors = response.data.errors;
                }
                if(response.data.error === false){
                    this.$bvToast.toast('Se actualizo correctamente la categoria', {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                    this._getCategoriesEmpresa();
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast('Parece que hubo un error en el servidor', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },
        async getCategoriesList(){
            this.setLoading(true)
            await this.$conectar.post('/empresa/categories/get-categories-list', {category_id: this.$route.params.id})
            .then(response =>{
                this.categoriesList = response.data.categoriesList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        addAttributeItemToAsigned(item){
            this.currentAttributes.push(item);
        },
        removeAsignedAttributeItem(index){
            this.currentAttributes.splice(index, 1);
        },
        back(){
            this.$router.go(-1);
        }

        
    }
}
</script>